import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';

import { FrontendIconsModule } from '@tablesready/frontend-icons';
import { DateStepperComponent } from './date-stepper.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgbDatepickerModule,
    FrontendIconsModule,
  ],
  declarations: [DateStepperComponent],
  exports: [DateStepperComponent],
})
export class DateStepperModule {}
